import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { generateClient } from 'aws-amplify/api';
import type { Schema } from '../../amplify/data/resource';
import PageHeader from '@/components/layout/PageHeader';
import Button from '@/components/ui/Button';
import Input from '@/components/ui/Input';
import Modal from '@/components/ui/Modal';

const client = generateClient<Schema>();

export default function SharedLists() {
  const [createOpen, setCreateOpen] = useState(false);
  const [newListName, setNewListName] = useState('');
  const [creating, setCreating] = useState(false);

  const { data: lists = [], refetch } = useQuery({
    queryKey: ['wine-lists'],
    queryFn: async () => {
      const { data } = await client.models.WineList.list();
      return data ?? [];
    },
  });

  async function handleCreate() {
    if (!newListName.trim()) return;
    setCreating(true);
    await client.models.WineList.create({ name: newListName.trim(), isPublic: false });
    setNewListName('');
    setCreateOpen(false);
    setCreating(false);
    refetch();
  }

  return (
    <div className="page page-lists">
      <PageHeader
        title="Shared lists"
        right={
          <Button size="sm" variant="secondary" onClick={() => setCreateOpen(true)}>
            + New list
          </Button>
        }
      />

      {lists.length === 0 ? (
        <div className="lists-empty">
          <p>No lists yet. Create one to share wines with family.</p>
          <Button variant="primary" onClick={() => setCreateOpen(true)}>Create a list</Button>
        </div>
      ) : (
        <ul className="lists-list">
          {lists.map((list) => (
            <li key={list.id} className="list-item">
              <p className="list-item-name">{list.name}</p>
              {list.isPublic && <span className="list-badge">Shared</span>}
            </li>
          ))}
        </ul>
      )}

      <Modal open={createOpen} onClose={() => setCreateOpen(false)} title="New list">
        <Input
          label="List name"
          value={newListName}
          onChange={(e) => setNewListName(e.target.value)}
          placeholder="e.g. Favourites, Braai wines"
          autoFocus
        />
        <Button variant="primary" onClick={handleCreate} loading={creating} fullWidth>
          Create
        </Button>
      </Modal>
    </div>
  );
}
